import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Input, Button, Typography, message } from 'antd';
import { socket } from '../socket';

const { Title } = Typography;

function Join() {
  const { channelId } = useParams();
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');

  const handleJoin = () => {
    if (!userName.trim()) {
      message.error('Please enter your name');
      return;
    }

    socket.emit('joinChannel', { channelId, userName });
    navigate(`/channel/${channelId}`);
  };

  return (
    <div style={{ 
      maxWidth: 400, 
      margin: '48px auto',
      padding: '0 24px'
    }}>
      <Card>
        <Title level={2} style={{ marginBottom: 24 }}>Join Session</Title>
        <Input
          placeholder="Enter your name"
          value={userName}
          onChange={e => setUserName(e.target.value)}
          style={{ marginBottom: 16 }}
          onPressEnter={handleJoin}
          size="large"
        />
        <Button 
          type="primary" 
          onClick={handleJoin}
          block
          size="large"
        >
          Join
        </Button>
      </Card>
    </div>
  );
}

export default Join; 